//@ts-ignore
import { tw } from '@careinfo/tailwind';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import Modal from './Reusable/Modal';
import GridCard from './GridCard';
import Button from './Reusable/Button';

const animatedComponents = makeAnimated();

const EditManifestStatus = (props: any) => {
  const [data, setData] = useState([]);
  const {
    openEditPopup,
    setOpenEditPopup,
    statusList,
    handleEditStatusChange,
    gridData,
    handleOpenEditPopup,
    handleStatusInclude,
    patchLoading,
    defaultValue,
  } = props;

  const { getValues } = useForm({});

  useEffect(() => {
    if (Array.isArray(gridData?.results || gridData)) {
      setData(gridData?.results || gridData);
    }
  }, [gridData]);

  return (
    <>
      <div className={tw`grid grid-cols-3 gap-x-8 gap-y-4`}>
        {data?.map((item: any, index: number) => (
          <React.Fragment key={index}>
            <GridCard
              key={index}
              item={item}
              props={{ ...getValues() }}
              handleOpenEditPopup={handleOpenEditPopup}
            />
          </React.Fragment>
        ))}
      </div>
      <Modal
        isOpen={openEditPopup}
        setIsOpen={setOpenEditPopup}
        title={'Select Status To Include'}
      >
        <div className={tw`mt-4`}>
          <form
            autoComplete='off'
            className={tw`flex gap-x-4 items-center justify-center`}
          >
            <div className={tw`w-3/4`}>
              <Select
                components={animatedComponents}
                closeMenuOnSelect={false}
                options={statusList}
                onChange={handleEditStatusChange}
                defaultValue={(() => {
                  return defaultValue.map((d: any) => ({
                    ...d,
                    value: d.id,
                    name: d.label,
                  }));
                })()}
                isMulti
              />
            </div>

            <div className={tw`w-[100px] `}>
              <Button
                label={'Update'}
                type={'button'}
                onClick={(e: any) => handleStatusInclude(e)}
                isLoading={patchLoading}
              />
            </div>
          </form>
        </div>
      </Modal>
    </>
  );
};

export default EditManifestStatus;
